import { c as _c } from "react/compiler-runtime";
import styled, { css, useTheme } from 'styled-components';
import { showChat } from '../../../../utils/liveChat';
import Badge from '../../../common/base/Badge';
import Button, { ClickableArea } from '../../../common/base/Button';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import DropdownMenu from '../../../common/DropdownMenu';
const StyledOnboardingNav = styled.div(({
  theme
}) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    padding: 0 ${theme.spacing(6)};
    height: 52px;
    z-index: 2;
    border-bottom: ${theme.border};
    background-color: ${theme.colors.surface.base.surface};
    z-index: ${theme.zindex.sticky};
  `);
const GuidedCreateConnectionNav: React.FC<{
  current_step: string;
  steps: {
    key: string;
    nav_label: string;
  }[];
}> = t0 => {
  const $ = _c(22);
  const {
    current_step,
    steps
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== current_step) {
    t1 = step => step.key === current_step;
    $[0] = current_step;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const index_of_current = steps.findIndex(t1);
  const logo_src = theme.mode === "dark" ? "/images/logo-symbol-white.svg" : "/images/logo-symbol.svg";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "center",
      gap: 4
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== logo_src) {
    t3 = <img src={logo_src} />;
    $[3] = logo_src;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DropdownMenu outline={true} parent_width={true} parent_size="medium" label="Create first connection" options={[{
      label: "Create first connection",
      icon: "connections",
      selected: true,
      to: "/create-first-connection"
    }, {
      label: "Get started with the CLI",
      icon: "terminal",
      selected: false,
      to: "/create-first-cli-connection"
    }]} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Div flex={t2}>{t3}{t4}</Div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      gap: 5
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== current_step || $[10] !== index_of_current || $[11] !== steps) {
    let t8;
    if ($[13] !== current_step || $[14] !== index_of_current) {
      t8 = (step_0, i) => <ClickableArea data-testid={`guided-create-connection-nav--${step_0.key}`} disabled={index_of_current < i} flex={{
        align: "center",
        gap: 2
      }} p={{
        x: 2,
        l: 1,
        y: 1
      }} rounded={true} key={step_0.key} onClick={() => {
        const element = document.getElementById(step_0.key);
        element?.scrollIntoView({
          behavior: "smooth"
        });
        return null;
      }}><Badge primary={current_step === step_0.key} neutral={current_step !== step_0.key} subtle={current_step === step_0.key}>{i + 1}</Badge><Text semi={true} muted={current_step !== step_0.key} primary={current_step === step_0.key}>{step_0.nav_label}</Text></ClickableArea>;
      $[13] = current_step;
      $[14] = index_of_current;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = steps.map(t8);
    $[9] = current_step;
    $[10] = index_of_current;
    $[11] = steps;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <Div flex={t6}>{t7}</Div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Div flex={{
      justify: "end",
      gap: 3
    }}><Button outline={true} icon="chat" onClick={showChat}>Help</Button><Button outline={true} icon="arrow_forward" to="/connections">Skip to dashboard</Button></Div>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t8) {
    t10 = <StyledOnboardingNav data-testid="guided-create-connection-nav">{t5}{t8}{t9}</StyledOnboardingNav>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default GuidedCreateConnectionNav;